namespace advisorop.components.common {

    export class AuditInformationController {
        $router;    
        public dgAudits: DevExpress.ui.dxDataGridOptions;
        audits: Array<domains.IAlertLog> = [];
        accountId: number;

        static $inject = ["generalService"];
        constructor(private generalService: services.GeneralService) {

            this.dgAudits = {
                export: {
                    enabled: true,
                    fileName: "Audits"
                },
                bindingOptions: {
                    dataSource: "vm.audits",
                },
                paging: { pageSize: 25 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                allowColumnResizing: false,
          
                noDataText: "No Audit Information",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "dateChanged", cellTemplate: "colDate", caption: "Occurred", width: 130 },
                    { dataField: "alertMessage", caption: "Event Message", encodeHtml: false, cellTemplate: "colMessage"},
                    { dataField: "user", caption: "User Action", width: 130, visible: true },
                    //{ dataField: "applicationDescription", caption: "System", width: 130, visible: false },
                    //{ dataField: "severityDescription", caption: "Severity", width: 130, visible: false }
                    //{ dataField: "id", caption: "#", cellTemplate: "colActions", width: 120 }
                ]
            };
        }

        loadAuditAccountInformation(accountId: number): void {
            this.generalService.getAuditAccountInformation(accountId)
                .then(response => {
                    this.audits = response.data;
                    this.dgAudits.dataSource = this.audits;
                }),
            err => this.generalService.showError(err.data);
        };


        getLogClass(alert: domains.IAlertLog): string {
            if (alert.severityId == domains.AlertSeverity.Warning)
                return "text-info";
            else if (alert.severityId == domains.AlertSeverity.Critical || alert.severityId == domains.AlertSeverity.Severe)
                return "text-danger";
            else if (alert.severityId == domains.AlertSeverity.FollowUpNeeded)
                return "text-info";
            else
                return "";
        }


        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }

        $onChanges(evt): void  {
            for (var key in evt) {
                if (key === "accountId" && this.accountId && this.accountId > 0) {
                    this.loadAuditAccountInformation(this.accountId);
                }
            }
        };

    }

    class AuditInformation implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accountId: "<",
                $router: "<"
            };
            this.controller = AuditInformationController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/audit-information.html';
        }
    }
    angular.module(Constants.APP).component("auditInformation", new AuditInformation());
}
